import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPaymentFraction } from 'src/app/state/paymentFractions/paymentFractions.models';
import { environment } from 'src/environments/environment';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';

@Injectable({
  providedIn: 'root'
})
export class FraccionamientoService {
  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiProducto}`;
  url: string;


  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }


  getFraccionamiento(idCotizacion: number) {
    return this.http.get<IHttpResponse<IPaymentFraction[]>>(`${this.url}/GetFractionationbyIdQuotation/${idCotizacion}`);
  }

  getFraccionamientoMensaje(fraccionPago: string, idCotizacion: number): Observable<any> {
    return this.http.get<any>(`${this.url}/GetFractionationMessagebyPayandIdQuotation/${fraccionPago}/${idCotizacion}`);
  }

}
